<section class="standard1 standard1-{{system}} bg-white-dark" *ngIf="lotName">
  <article class="content-wrap txt-center">
    <h2 class="uppercase margin-bottom-40 normal-3">{{'HOW' | translate }}</h2>
    <div class="row">
      <div class="col-4">
        <h4 class="{{system}}">{{'STEPS.ONE.TITLE' | translate}}</h4>

        <div class="imagen-steps">
          <img
            class="number"
            [src]="'https://d3tmfelegj51yl.cloudfront.net/landings/discount-product/images/'+lotName+'/'+system+'/'+('lang' | translate)+'/number-01.svg'"
            alt=""
          />
          <img
            class="rounded"
            [src]="'https://d3tmfelegj51yl.cloudfront.net/landings/discount-product/images/'+lotName+'/'+system+'/'+('lang' | translate)+'/3steps-01.jpg'"
            alt="img-fluid"
          />
        </div>

        <p>{{'STEPS.ONE.CONTENT' | translate}}</p>
      </div>
      <div class="col-4">
        <h4>{{'STEPS.TWO.TITLE' | translate}}</h4>

        <div class="imagen-steps">
          <img
            class="number"
            [src]="'https://d3tmfelegj51yl.cloudfront.net/landings/discount-product/images/'+lotName+'/'+system+'/'+('lang' | translate)+'/number-02.svg'"
            alt=""
          />
          <img
            class="rounded"
            [src]="'https://d3tmfelegj51yl.cloudfront.net/landings/discount-product/images/'+lotName+'/'+system+'/'+('lang' | translate)+'/3steps-02.jpg'"
            alt="img-fluid"
          />
        </div>

        <p>
          <ng-container *ngIf="system === 'ltk'"> {{'STEPS.TWO.CONTENT-LTK' | translate}} </ng-container>
          <ng-container *ngIf="system === 'wt'"> {{'STEPS.TWO.CONTENT-WT' | translate}} </ng-container>
        </p>
      </div>
      <div class="col-4">
        <h4>{{'STEPS.THREE.TITLE' | translate}}</h4>

        <div class="imagen-steps">
          <img
            class="number"
            [src]="'https://d3tmfelegj51yl.cloudfront.net/landings/discount-product/images/'+lotName+'/'+system+'/'+('lang' | translate)+'/number-03.svg'"
            alt=""
          />
          <img
            class="rounded"
            [src]="'https://d3tmfelegj51yl.cloudfront.net/landings/discount-product/images/'+lotName+'/'+system+'/'+('lang' | translate)+'/3steps-03.jpg'"
            alt="img-fluid"
          />
        </div>
        <p>{{'STEPS.THREE.CONTENT' | translate}}</p>
      </div>
    </div>
  </article>
  <div class="arrow-down">
    <a href="#selecciona">
      <img class="img-fluid" [src]="'https://d3tmfelegj51yl.cloudfront.net/landings/discount-product/images/'+system+'/arrow-down.svg'" alt="" />
      <!-- CAMBIAR URL PARA QUE NO DEPENDA DEL PRODUCTO Y EL IDIOMA -->
    </a>
  </div>
</section>
